import { hasDeliveryRevision } from './checkoutDeliveryAuthority';

// The acknowledged quote is authoritative: a removed fee must not be replayed
// from a previous form selection, and each tip/fee ID is sent only once.
export const checkoutFees = (checkout) =>
  (checkout?.fees || [])
    .filter((fee) => fee.adjustable || fee.adjustable_percentages)
    .map(({ id, amount }) => ({ id, amount }));

export function currentCheckoutFees(fees, checkout) {
  const eligible = new Set(checkoutFees(checkout).map(({ id }) => String(id)));
  const unique = new Map();
  (fees || []).forEach(({ id, amount }) => {
    if (eligible.has(String(id))) unique.set(String(id), { id, amount });
  });
  return [...unique.values()];
}

export function validateCheckoutAdjustment(checkout, acknowledgment) {
  if (
    (acknowledgment?.checkout_id != null &&
      acknowledgment.checkout_id !== checkout.id) ||
    ((checkout.delivery_revision ||
      acknowledgment?.delivery_revision != null) &&
      (acknowledgment?.checkout_id !== checkout.id ||
        !hasDeliveryRevision(acknowledgment?.delivery_revision)))
  )
    throw new Error('Checkout quote could not be confirmed. Please retry.');
}
